var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg3DTour = function Svg3DTour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#3d-tour_svg__a)",
    fill: "#141413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.51.216v.861c1.068.14 2.08.295 3.02.469 4.525.833 6.136 1.847 6.136 2.514 0 .667-1.611 1.677-6.135 2.514-3.653.674-8.36 1.083-13.441 1.177v.854C38.52 8.4 48.813 6.82 48.813 4.056c0-1.802-4.37-3.097-10.303-3.84ZM23.058 7.74c-4.909-.11-9.442-.517-12.982-1.17C5.55 5.737 3.94 4.723 3.94 4.056s1.611-1.677 6.136-2.514c.384-.07.782-.139 1.189-.205V.47c-4.978.768-8.472 1.976-8.472 3.587 0 2.723 9.994 4.295 20.265 4.535v2.167l4.35-2.563-4.35-2.559V7.74Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "3d-tour_svg__a",
    x: 0.793,
    y: 0.216,
    width: 50.02,
    height: 14.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1869_692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1869_692",
    result: "shape"
  })))));
};

export default Svg3DTour;